import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_0411bc8a-f562-425b-a1dd-f5f58614235d/artifacts/xk13ab9h_image.png";

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Programs', path: '/programs' },
  { name: 'Grants', path: '/grants' },
  { name: 'Get Involved', path: '/get-involved' },
  { name: 'Contact', path: '/contact' },
];

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-header" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <img 
              src={LOGO_URL} 
              alt="Players Health Foundation" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                className={`text-sm font-semibold transition-colors ${
                  location.pathname === link.path
                    ? 'text-[#5B4FF9]'
                    : 'text-[#272926] hover:text-[#5B4FF9]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://givebutter.com/players-health-foundation-website-button-suv1ls"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm"
              data-testid="nav-donate-btn"
            >
              Donate
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle mobile menu"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-[#272926]" />
            ) : (
              <Menu className="h-6 w-6 text-[#272926]" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav 
            className="md:hidden py-4 border-t border-zinc-200"
            data-testid="mobile-nav"
          >
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  className={`text-base font-semibold transition-colors ${
                    location.pathname === link.path
                      ? 'text-[#5B4FF9]'
                      : 'text-[#272926] hover:text-[#5B4FF9]'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://givebutter.com/players-health-foundation-website-button-suv1ls"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary text-center text-sm"
                data-testid="mobile-nav-donate-btn"
                onClick={() => setMobileMenuOpen(false)}
              >
                Donate
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
